// Copied and modified from
// https://github.com/kyamagu/js-segment-annotator/blob/master/js/image/segmentation/base.js
// at 1cc466e0172a3d45c62a5b119b05c9a29319327a

/**
 * Base class for over-segmentation algorithms.
 *
 * Copyright 2015  Kota Yamaguchi
 */

/////////////////////
// begin sama changes
// -- we only support Chrome so don't need a work-around to create
// valid ImageData, which is not supported in IE
// @ts-ignore
export function BaseSegmentation(this: any, originalImageData, options) {
  this.imageData = new ImageData(
    originalImageData.width,
    originalImageData.height,
  );
  // end sama changes
  ///////////////////
  this.imageData.data.set(originalImageData.data);
}

/////////////////////
// begin sama changes
// -- deleted finer/coarser controls here, control it from
// our code instead by creating a new algorithm for each re-computation
// end sama changes
///////////////////
